<template>
  <div class="box-re">
    <div v-if="step > 1">
      <div class="search btnLists" style="margin-top:0">
        <el-input
          class="search-input"
          style="width: 100%"
          maxlength="50"
          v-model="form.searchValue"
          @change="filiterAllList"
          placeholder="请选择被申请人"
        ></el-input>
        <div
          class="primary-btn"
          style="margin-left: 12px;height:40px;line-height:40px"
          @click="handleItem"
        >选择</div>
      </div>
      <div style="max-height: 500px; overflow-y: auto" v-loading="loading">
        <el-tree :data="list" :props="defaultProps">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <el-radio
              size="medium"
              v-if="!data.childs"
              :label="data.id"
              v-model="radio"
            >{{ node.label }}</el-radio>
            <span v-else>{{ node.label }}</span>
          </div>
        </el-tree>
      </div>
    </div>

    <div v-else >
      <div style="max-height: 70vh;overflow-y:auto">
         <img :src="`${path}respondent_tip.png`" alt="" srcset="">
      </div>

      <div class="btnLists" style="text-align:right">
        <div class="primary-btn" style="width:100%" @click="next">下一步</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@api/api";
import antistop from "@/utils/antistop";
export default {
  name: "respondentList",
  data() {
    return {
      dialogVisible: false,
       path:window.location.origin + window.location.pathname,
      list: [],
      radio: null,
      step: 1,
      allTreeData: [],
      defaultProps: {
        children: "childs",
        label: "name"
      },
      loading: false,
      form: {
        searchValue: ""
      },
      selectItem: {} // 选择的当前数据
    };
  },
  watch: {
    radio: function(val) {
      const item = this.allDataSource.find(item => item.id == val);
      console.log(item);
      this.form.searchValue = item.name;
    }
  },
  props: {
    allDataSource: {
      type: Array,
      default: () => []
    },
    istraffic: {
      type: "String",
      default: () => ""
    }
  },
  methods: {
    next(){
      this.step = this.step + 1
    },
    // 选择非标
    handleItem() {
      if (this.form.searchValue == "") {
        return this.$toast("请选择要使用的被申请人");
      }
      const dataItem = this.allDataSource.find(
        item => item.name == this.form.searchValue
      );
      if (dataItem) {
        this.$emit("selected", dataItem);
        return;
      } else {
        return this.$message.warning('请选择要使用的被申请人')
      }
      // 被申请人只能选择导致以下判断用不到了 2025.02.10
      const ANTISTOP = antistop.AntiStop;

      if (
        this.form.searchValue.includes(
          ANTISTOP.find(item => this.form.searchValue.includes(item))
        )
      ) {
        this.$toast({
          message: "被申请人填写有误，请重新选择或填写正确的被申请人信息",
          type: "warning",
          duration: 4000
        });
      } else {
        this.$toast({
          message: "被申请人可能不正确，如确认无误，请手动选择复议机关并提交",
          duration: 4000
        });
        setTimeout(() => {
          this.$emit("inputed", this.form.searchValue);
        }, 2000);
      }
    },
    // 搜索内容
    filiterAllList() {
      this.loading = true;
      if (!this.form.searchValue) {
        this.list = this.allTreeData;
        this.loading = false;
      } else {
        let field = this.istraffic == 1 ? "allTreeData" : "allDataSource";
        this.list = this[field].filter(d => {
          return d.name.indexOf(this.form.searchValue) > -1;
        });
        this.loading = false;
      }
    },
    init() {
      this.form.searchValue = "";
      this.step = 1
      this.getAllDTree();
    },
    // 获取全部列表数据
    getAllDTree() {
      let filter = {
        name: this.istraffic == "1" ? "交通警察,交通管理" : ""
      };
      Api.getEntrustingAllDepartTree({
        ...filter
      }).then(({ data }) => {
        this.allTreeData = data.code == 0 ? data.data : []; // 获取的全部tree数据
        this.list = data.code == 0 ? data.data : [];
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectItem = {};
    }
  }
};
</script>

<style scoped>
.box-re {
  padding: 16px;
}
.search {
  display: flex;
  padding-top: 16px;
  align-items: center;
}

::v-deep .el-tree-node__content {
  height: 100%;
}
::v-deep .el-radio__inner {
  width: 18px;
  height: 18px;
}
.custom-tree-node {
  height: 40px;
  line-height: 40px;
}
</style>
